export enum Resize {
  NONE = "none",
  VERTICAL = "vertical",
}
